import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { services } from '../../mock';
import { iconMap } from './iconMap';

export const ServicesSection = () => (
  <section id="services" data-testid="services-section" className="fade-in-section py-12 md:py-20 px-4 bg-gradient-to-b from-warmBeige/80 to-white/80 backdrop-blur-sm relative z-10">
    <div className="container mx-auto relative z-10">
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-darkBrown mb-4">Services We Offer</h2>
        <p className="text-sm md:text-xl text-gray-600 max-w-3xl mx-auto">
          Pursue greater heights and commit to bettering yourself with our care.
        </p>
        <div className="w-24 h-1 bg-primaryOrange mx-auto mt-4"></div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
        {services.map((service, index) => {
          const Icon = iconMap[service.icon];
          return (
            <Card
              key={service.id}
              className="group border-none shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 overflow-hidden"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative h-36 md:h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-darkBrown/70 to-transparent"></div>
                <div className="absolute bottom-3 left-3 md:bottom-4 md:left-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-primaryOrange rounded-lg flex items-center justify-center">
                    <Icon className="text-white" size={20} />
                  </div>
                </div>
              </div>
              <CardHeader className="p-3 md:p-6">
                <CardTitle className="text-darkBrown text-lg md:text-2xl">{service.title}</CardTitle>
              </CardHeader>
              <CardContent className="p-3 pt-0 md:p-6 md:pt-0 space-y-3 md:space-y-4">
                <p className="text-xs md:text-sm text-gray-600">{service.description}</p>
                <a
                  href={service.learnMoreUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-primaryOrange hover:text-accentOrange font-semibold transition-colors group/link text-sm"
                >
                  Learn More
                  <ChevronRight className="ml-1 group-hover/link:translate-x-1 transition-transform" size={16} />
                </a>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);
